import { Navigate } from "react-router-dom";
import { useSettingsStore } from "../stores/index.js";

/** The index route ("/"): redirect to the user's configured default view once
 *  settings have hydrated (Shell triggers that). Renders nothing until then so
 *  we don't flash a hardcoded view before the preference is known. */
export function DefaultRedirect() {
  const loaded = useSettingsStore((s) => s.loaded);
  const defaultView = useSettingsStore((s) => s.defaultView);
  if (!loaded) return null;
  return <Navigate to={`/${defaultView}`} replace />;
}
